import { render, staticRenderFns } from "./ManagedList.vue?vue&type=template&id=78050878&scoped=true"
import script from "./ManagedList.vue?vue&type=script&lang=js"
export * from "./ManagedList.vue?vue&type=script&lang=js"
import style0 from "./ManagedList.vue?vue&type=style&index=0&id=78050878&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78050878",
  null
  
)

export default component.exports